import { render, staticRenderFns } from "./apply.vue?vue&type=template&id=b33c6e6c&scoped=true"
import script from "./apply.vue?vue&type=script&lang=ts"
export * from "./apply.vue?vue&type=script&lang=ts"
import style0 from "./apply.vue?vue&type=style&index=0&id=b33c6e6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33c6e6c",
  null
  
)

export default component.exports